module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Mi pedido":"Mi pedido"},"en":{},"ca":{"Mi pedido":"La meva comanda"}}')
  delete Component.options._Ctor
}
